var React = require('react');

function SoundMute (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.834 8.6665L13.834 11.6665","stroke":"#041C1B","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.834 11.6665L13.834 8.6665","stroke":"#041C1B","strokeLinecap":"square","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4.33824 11.0667C3.62713 10.5333 3.62713 9.46667 4.33824 8.93333L10.916 4L10.916 16L4.33824 11.0667Z","stroke":"#041C1B","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

SoundMute.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = SoundMute;

SoundMute.default = SoundMute;
